<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <div *ngIf="isFetching && imageReferences.length == 0" fxFill fxLayoutAlign="center center">
      <fa-icon class="icon loading_spinner" [icon]="faSpinnerThird"></fa-icon>
    </div>

    <div #gallery class="gallery">
      <virtual-scroller
        #vScroller
        [items]="imageReferences"
        [parentScroll]="gallery"
        (vsEnd)="onScroll($event)"
      >
        <div
          class="image_tile"
          *ngFor="let imgRef of vScroller.viewPortItems"
          fxLayout="column"
          (click)="onImageSelected(imgRef)"
        >
          <div class="item-wrapper" [ngClass]="selectedImage.includes(imgRef) ? 'selected' : ''">
            <img httpSrc="{{ imgRef.image }}" />
            <div class="image_info" fxLayout="column">
              <span class="image_caption">{{ imgRef.task ? imgRef.task : 'untitled' }}</span>
              <div fxLayout="row">
                <span class="image_timestamp">{{
                  customDateFormatService.formatDate(imgRef.exifData?.['DateTimeOriginal']?.['description'] ? convertExifDateToDate(imgRef.exifData!['DateTimeOriginal']['description']) : imgRef.timestamp, DateFormat.short)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </virtual-scroller>
    </div>

    <div *ngIf="selectedImage.length > 0" class="details_area">
      <div class="details-close-button">
        <button mat-icon-button (click)="selectedImage.pop()">
          <fa-icon [icon]="faXmarkLarge" aria-label="close button"></fa-icon>
        </button>
      </div>

      <div class="details_container" fxLayout="column" fxLayoutGap="24px">
        <div class="details-image-slider">
          <app-image-slider
            [images]="selectedImage"
            [imageSize]="{ width: 270, height: 200 }"
            [manageImageRatio]="true"
            [displayBorder]="false"
            [stretchToContainer]="true"
            (imageClick)="onImageClick(selectedImage[0])"
            (lightboxClose)="onLightBoxClose(selectedImage[0])"
          ></app-image-slider>
        </div>

        <div class="details_item">
          <span class="text-bold details_item_name" i18n="task label@@taskLabel">Task</span>
          <nav-link
            class="details_item_value"
            [route]="getTaskRoute(selectedImage[0].taskId)"
            [text]="selectedImage[0].task ?? selectedImage[0].taskId"
          ></nav-link>
        </div>

        <div class="details_item">
          <span class="text-bold details_item_name" i18n="workflow label@@workflowLabel"
            >Workflow</span
          >
          @if (enableLink) {
          <nav-link
            class="details_item_value"
            [route]="getWorkflowRoute(selectedImage[0].workflowId)"
            [text]="selectedImage[0].workflow ?? selectedImage[0].workflowId"
          ></nav-link>
          } @else {
          <span>{{ selectedImage[0].workflow ?? selectedImage[0].workflowId }}</span>
          }
        </div>

        <div class="details_item" *ngIf="selectedImage[0].description">
          <span class="text-bold details_item_name" i18n="@@description">Description</span>
          <span class="details_item_value">{{ selectedImage[0].description }}</span>
        </div>

        <div
          class="details_item"
          *ngIf="selectedImage[0].exifData?.['DateTimeOriginal']?.['description']"
        >
          <span class="text-bold details_item_name" i18n="@@imageCreated">Image created</span>
          <span class="details_item_value">{{
            customDateFormatService.formatDate(
              convertExifDateToDate(selectedImage[0].exifData!['DateTimeOriginal']['description']),
              DateFormat.short
            )
          }}</span>
        </div>

        <div class="details_item" *ngIf="selectedImage[0].executedBy.length > 0">
          <span class="text-bold details_item_name" i18n="@@taskExecutedBy">Task executed by</span>
          <span class="details_item_value">{{ selectedImage[0].executedBy.join(', ') }}</span>
        </div>

        <div
          class="details_item"
          *ngIf="selectedImage[0].exifData?.['Image Width']?.['value'] && selectedImage[0].exifData?.['Image Height']?.['value']"
        >
          <span class="text-bold details_item_name" i18n="@@resolution">Resolution</span>
          <span class="details_item_value"
            >{{ selectedImage[0].exifData!['Image Width']['value'] }}x{{
              selectedImage[0].exifData!['Image Height']['value']
            }}</span
          >
        </div>

        <div
          class="details_item"
          *ngIf="selectedImage[0].exifData?.['GPSLatitude']?.['description'] && selectedImage[0].exifData?.['GPSLongitude']?.['description']"
        >
          <span class="text-bold details_item_name" i18n="@@location">Location</span>
          <app-map
            class="map"
            [taskStatesLocation]="
              convertExifGpsToLocationTag(
                selectedImage[0].exifData!['GPSLatitude']['description'],
                selectedImage[0].exifData!['GPSLongitude']['description']
              )
            "
            [zoomDisabled]="true"
            [panDisabled]="true"
          ></app-map>
        </div>
      </div>
    </div>
  </div>
</div>
